import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {imageMap} from "../../../../images/imageMap.ts";

export default function GravningArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className={'text-box text-box--gray'}>
                        <p>
                            Har du planer om pool, trampolin, rosenbed, ny indkørsel eller lignende?
                            Så læs med her, inden du kaster dig over projekterne.
                            Når du har fået installeret fiber, er der nemlig et par ting, du skal være obs på, inden du begynder at grave.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Før du graver</h2>
                        <p>
                            Forud for ethvert bygnings- eller jordarbejde skal du undersøge, om der er kabler i området.
                            Det fremgår af §5 i loven om graveadgang mv.
                            Du kan finde lednings&shy;oplysninger via <a href="https://ler.dk/Portal/P.1.Forside.aspx" target="_blank">LER.dk</a>.
                            Du kan også kontakte os i Hiper, og så kan vi hjælpe dig med at finde den information, du har brug for.
                        </p>
                        <p>
                            Du bør i god tid, undersøge om der er kabler i dit område og senest 5 arbejdsdage, før du begynder arbejdet.
                        </p>
                    </div>
                    <img
                        className={'paragraph-image'}
                        src={imageMap.help.subscription.gravning_ledningsoplysninger}
                        alt="Illustration af en plantegning over et hus og nogle kabler."
                    />
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Når du graver</h2>
                        <p>
                            Du skal sørge for at overholde respektafstanden, som er 0,5 meter på hver side af den angivne kabeltracé på kabel&shy;planen.
                            Inden for respektafstandsområdet skal du håndgrave forsigtigt med skovl eller spade &ndash; aldrig med greb.
                        </p>
                        <p>
                            Du må aldrig maskingrave eller bruge kabelplov eller lignende maskineri, da der er for stor risiko for at gøre skade på kablerne.
                            Dette gælder også ved gravning parallelt med et kabel.
                            Ved krydsning af et kabel skal kablet først lokaliseres ved håndgravning.
                        </p>
                    </div>
                    <img
                        className={'paragraph-image'}
                        src={imageMap.help.subscription.gravning_respektafstand}
                        alt="Info grafik der viser hvor man skal håndgrave, og hvor man kan grave med skovl og maskine."
                    />
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Kablernes dybde</h2>
                        <ul className="list list--bullet">
                            <p>
                                Kablerne ligger i meget varierende dybde alt efter forholdene:
                            </p>
                            <li><p>
                                Langs veje uden for byområder ligger kablerne normalt i 0,4-0,6 meters dybde, men ved efterfølgende overfladeregulering kan dybden være ændret.
                            </p></li>
                            <li><p>
                                I byområder kan kablerne ligge direkte under fortovs- eller vejbelægning.
                            </p></li>
                            <li><p>
                                I landbrugsjord vil dybden ofte være ca. 1,1 meter.
                            </p></li>
                        </ul>
                        <p>
                            Der er ingen sikker dybde.
                            Derfor skal du altid arbejde forsigtigt med håndredskaber inden for respektafstanden.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Håndtering af kabler</h2>
                        <p>
                            Ryk aldrig i kablerne.
                            De tåler ikke at blive strakt, og de får indre kvæstelser.
                        </p>
                        <p>
                            Træd heller ikke på kablerne.
                            Træder du på et kabel, ødelægges det indvendigt, også selv om du ikke kan se noget udvendigt på kablet.
                        </p>
                        <p>
                            Der kan være flere kabler i samme tracé og i forskellig dybde, uden at det fremgår af kabelplanen.
                            Kabler kan også ligge i rør eller rørledninger.
                            Derfor skal du håndgrave forsigtigt inden for respektafstanden, selv om du allerede har fundet et kabel i tracéet.
                        </p>
                        <p>
                            Kabelmuffer dækker sammensplidsninger på kablet.
                            De er sårbare og beskadiges let.
                            Derfor skal alle muffer understøttes, inden du flytter kablet.
                            Vi anbefaler, at du binder/taper et bræt, der er ca. 20 cm længere end muffen på hver side, fast under muffen.
                            Brættet fjerner du igen, når kablet er endeligt placeret i kabelgraven.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Undgå at bruge jernpløkker</h2>
                        <p>
                            Slå aldrig jernpløkker i jorden, medmindre du er helt sikker på, at der ikke er kabler i nærheden.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Jeg har gravet mine fiberkabler over</h2>
                        <p>
                            Det er altid skadeforvolderen, som skal betale for udbedring af fejlen.
                            Derfor bør du følge alle ovenstående retningslinjer, så du undgår skader.
                        </p>
                        <p>
                            Hvis du beskadiger et kabel eller en muffe under gravearbejdet, skal du ringe til os, også selvom du blot har en formodning om en skade.
                            Ved at kontakte os kan du medvirke til at begrænse de forstyrrelser, der opstår som følge af en kabelskade.
                            Jo hurtigere der bliver grebet ind, desto mindre bliver skaden og dermed omkostningerne.
                        </p>
                        <p>
                            Er det beskadigede kabel udsat for vand eller jordfugt, bør du straks pakke skaden forsigtigt ind i plastik eller lignende.
                        </p>
                        <p>
                            Hvis du kan, bør du forsigtigt grave kablet frit på skadestedet, så teknikeren hurtigt kan komme til at arbejde med fejlen.
                            Det sparer både tid og penge og er dermed med til at minimere dine omkostninger.
                        </p>
                        <p>
                            Husk altid at anmelde mindre kabelskaber &ndash; også selv om de virker som en bagatel.
                            Sådanne skader kan give kabelfejl eller funktionssvigt på et senere tidspunkt, og kan ofte være svære at lokalisere.
                            Det er oftest muligt at finde frem til skadeforvolderen, som så må betale reparation og gravearbejde og det kan blive en dyr omgang for vedkommendeskadeforvolder på sigt.
                        </p>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "mit-abonnement",
                        "article": "mit-hiper",
                        "name": "Mit Hiper"
                    },
                    {
                        "category": "bestilling",
                        "article": "kan-jeg-faa-1000-mbit",
                        "name": "Kan jeg få 1.000 Mbit?"
                    }
                ]}
            />
        </>
    )
}
